<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<header>
<h1 class="topictitle1" id="ch10"><a href="#/nav#nch10"><span class="section_number">CHAPTER 5</span><br/><span class="title">THE TRIP TO THE SWAMP</span></a></h1>
</header>
<p>Anand and Terraclon had no rags to change into, but nudity was a serious crime on the Slope. They cut shoots of new grass,
            pierced the middles with holes and made capes of them. They fashioned antennae from grass fibers, wiped them with kin-scent,
            and tied them to their heads. No sooner were they dressed than Keel put them to the gruesome work of porting corpses to the
            swamp at the edge of the Freshwater Lake. The lake was considered polluted since it was shared with the enemy Seed Eaters,
            so there was no worry they were ruining Cajoria’s drinking water. Not that this made dragging dead bodies any more pleasant.
         </p>
<p>The boys reported to a man from the steering caste, who, like most of the mound’s workers, was starving and had sunken cheeks.
            Using his shriveled limbs, he handed the boys turbans scented with <i>leaf-finding-scent</i>. The boys strapped themselves into reins attached to trucking ants hitched to vats stuffed with stinking dead men. Once the
            boys put on the turbans, the trucking ants could not help but follow and lug the vats behind them.
         </p>
<p>The two friends dreaded the tedious hike to the Punk Weed Wilds, but they picked up batting poles from a pile. “The end will
            be in sight,” said Anand, “once we take the first step.” Terraclon, who was usually chatty, was as silent as stone as they
            trudged along.
         </p>
<p>“You’re quiet today,” said Anand.</p>
<p>Terraclon exhaled, looking away from Anand.</p>
<p>“My parents have stopped speaking your name, Anand. They just call you ‘that half-breed boy.’”</p>
<p>“So?”</p>
<p>“So they think you will make me unmarriageable and tempt me into eating roach flesh. They say I am too old to spend time with
            you.”
         </p>
<p>Anand rolled his eyes at this. “Again, Ter. I’ve never eaten roach flesh. Neither has my mother. Her people eat roach <i>eggs,</i> but only when there is no other food to be had.”
         </p>
<p>“You know what my dad says about her . . . that she worships a roach demon. And she steals Slopeish babies and stains them
            with roach dye to make them dark. Some are raised as Britasytes and some are fattened and eaten.”
         </p>
<p>“Ter, you know my mother. She’s never been a cannibal and neither are her people. And they would never raise a Slopeite as
            one of their own.”
         </p>
<p>“Why not?”</p>
<p>“They think the Slopeites, and the Cajorites in particular, are as stupid as they are ugly.”</p>
<p>“They think <i>we’re</i> ugly?”
         </p>
<p>“Hideous. And you are, you know. All of you Slopeish people. And you stink.”</p>
<p>“<i>We </i>stink?”
         </p>
<p>“The Britasytes think the smell of ants is nauseating. They can’t understand why anyone would link their lives to creatures
            as vile as leaf-cutters.”
         </p>
<p>Terraclon laughed, revealing his oversized teeth. Using their poles, they swatted at the flies buzzing about the carts. When
            one refused to fly off, Anand looked around to see if they were alone, then used his pole to stun the fly with a hard knock
            to its head. When the fly fell, Anand used the sharp end to stab thorough its brain.
         </p>
<p>“Impressive!” said Terraclon as he slapped Anand’s back. “Who taught you this?”</p>
<p>“All roach people are hunters, including my mother.”</p>
<p>Anand tore open the fly’s abdomen with his knife, scooped out some of the lymph, and ate it.</p>
<p>“What are you doing?” asked Terraclon, suddenly wary and looking both ways.</p>
<p>“I’m eating. Come on. Let’s get some fat on your frame.”</p>
<p>“That fly belongs to the royals!”</p>
<p>“The fly belongs to us if we eat it,” said Anand.</p>
<p>“When you’re hungry, it’s hard not to see the point in that,” said Terraclon as he quickly scooped out some green flesh. When
            they finished eating and resumed their trek, carrion beetles crawled up from their holes to munch on the fly’s remains, effectively
            removing the evidence.
         </p>
<p>Terraclon was singing in a high, clear voice as they walked around a defoliated bortshu tree. It took the boys thousands of
            steps to traverse the trunk. Ter stopped singing when they heard war song in the distance.
         </p>
<p>Heading their way were the last of the Slopeish soldiers returning from the conflict with the neighboring Seed Eaters. As
            usual, they were singing the Hymn of Glories that boasted of Slopeish invincibility. Some of the men were carrying upright
            pikes with the severed heads of Seed Eater soldiers on their points.
         </p>
<p>The boys pulled their vats off the path as the soldiers approached. Ter bowed his head and glued his eyes to the sand as the
            procession made its way. Anand bent his head to the ground, but his eyes peered up. The soldiers rode on the tallest of ants
            with mandibles that were large and lethal and exoskeletons that were a deep and glossy yellow. Around the men’s necks were
            the breathing filters they wore when fighting the Seed Eaters, whose harvester ants sprayed noxious battle fumes.
         </p>
<p>Slopeish soldiers may have spent all their days in preparation to kill and be killed, but to Anand it seemed they were always
            smiling, something he resented. When he stole an upwards glimpse, his head was smacked by the flat of a sword. He looked up
            to see a chiding soldier, nearly as young as himself.
         </p>
<p>“Eyes to the sand, boy,” said the soldier and Anand’s ears went hot. He gazed at the ground until the procession passed.</p>
<p>The boys reached the edge of the marsh with towering punk grass that waved its brown cylinders in the wind. They dumped the
            contents of their carts, then backed away as water bugs swam up from the swamp and converged on the corpses.
         </p>
<p>“I hate them and what they do to us,” Anand said. “But sometimes I wish I was with them.”</p>
<p>“With who?”</p>
<p>“The soldiers,” Anand said as he kicked up a sand grain.</p>
<p>“You will be with them—some time when they go to war. Even soldiers have to wipe their bottoms.”</p>
<p>“I’m not talking about carting off their shit. I’m talking about fighting.”</p>
<p>“Fighting? You? Let them fight and die! Look at our legless, one-eyed king at the next assembly and then tell me you want
            to be a soldier.”
         </p>
<p>“But at least he’s lived!”</p>
<p>“At least we’re intact.”</p>
<p>Anand rolled his eyes. “Come on, Ter. Haven’t you ever wanted to do something besides clean chamber pots?”</p>
<p>“No point in thinking about it. We are born to our tasks, just as the ants are hatched to theirs.”</p>
<p>“But you have thought about it.”</p>
<p>Terraclon obviously had. He looked over at a tuft of razor grass where he kept something hidden.</p>
<p>“Can you keep a secret?” he asked.</p>
<p>Anand nodded and Terraclon disappeared behind the grass. He huffed and puffed as he pushed aside a pebble, then unfolded something
            wrapped in rags. “Turn your back,” he said, as he snapped a flower from a spray of dwarf lilies. Anand kept his back turned
            and heard the sounds of dressing.
         </p>
<p>“All right,” Terraclon said. “Turn and bow before me.”</p>
<p>Anand turned, then burst into laughter. Terraclon was arrayed in a parody of royal dress with jackets and trains. It was a
            patchwork of rags that had been salvaged from the royal trash. He wore the lily as a miter and its yellow pollen was smeared
            on his face. He strutted about, wielding his pole as if it were a scepter.
         </p>
<p>“I have a secret, too,” Anand said when he could stop laughing. “Time to turn your back!”</p>
<p>Terraclon obeyed. Anand cut a shard from a saddle-leaf plant and draped it over the spiny thorax of the trucking ant. He took
            off his turban and wrapped it at the end of his pole. Terraclon heard Anand climbing and then the ant taking steps.
         </p>
<p>“Turn around,” Anand said.</p>
<p>Terraclon screeched. Anand was riding on the ant, guiding it with his turban.</p>
<p>“Anand! What are you doing?”</p>
<p>“I’m riding.”</p>
<p>“Get off that ant <i>now</i>!<i> </i>It’s forbidden!”
         </p>
<p>Anand laughed as he rode the ant in a circle. Terraclon trembled, then climbed the ant’s leg spikes and yanked Anand to the
            ground where they fell in a tangle.
         </p>
<p>“If the sheriffs see you on an ant, they’ll cut your legs off!” Terraclon shouted as the two rose to their feet.</p>
<p>“Why, then I’ll look like our king. And with that outfit, you can be queen. Your turn—get up there,” Anand said, pushing him.</p>
<p>“No! If you ever ride on an ant again, I won’t be your friend.”</p>
<p>“All right, all right,” Anand responded. “Trucking ants are boring as rides anyway. Help me hitch her to the cart. ”</p>
<p>On their return, the boys detoured into a dense growth of bucket orchids whose roots clung to the shady side of an old tree.
            After docking the ants, they climbed an orchid to steal a nap in the tubular beard of its flower. It was sweet and waxy inside,
            with lavender light that bled through the flower’s freckles.
         </p>
<p>When Anand drifted into sleep, he dreamt of himself in a soldier’s armor riding atop a saddled ant. He saw himself leading
            an army of thousands against an even greater enemy. He woke from the dream, startled and sweating. <i>Why have I seen someone else’s future?</i> he asked himself. <i>Roach people are traders, never soldiers.</i></p>
<p><i>And right now, I’m neither.</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter_5.vue?83f1d312